import Vue from 'vue';
import Vuex from 'vuex';
import axios from 'axios';

Vue.use(Vuex);

export default new Vuex.Store({
  state: {
    status: '',
    user: JSON.parse(localStorage.getItem('user') || null),
    nextPage: '',
  },

  mutations: {
    auth_request(state) {
      state.status = 'loading';
    },
    auth_success(state, user) {
      state.status = 'success';
      state.user = user;
    },
    auth_error(state) {
      state.status = 'error';
    },
    logout(state) {
      state.status = '';
      state.user = null;
    },
    setNextPage(state, payload) {
      const changeState = state;
      changeState.nextPage = payload;
    },
  },

  actions: {

    login({ commit }, user) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        axios({ url: `${process.env.VUE_APP_BACKEND_URL}auth/login/`, data: user, method: 'POST' })
          .then((resp) => {
            const loginUser = resp.data.user;
            localStorage.setItem('user', JSON.stringify(loginUser));
            axios.defaults.headers.common.Authorization = loginUser.token;
            commit('auth_success', loginUser);
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            localStorage.removeItem('user');
            reject(err);
          });
      });
    },

    verify({ commit }) {
      return new Promise((resolve, reject) => {
        commit('auth_request');
        axios({ url: `${process.env.VUE_APP_BACKEND_URL}auth/verify/`, method: 'POST' })
          .then((resp) => {
            const loginUser = resp.data.user;
            localStorage.setItem('user', JSON.stringify(loginUser));
            axios.defaults.headers.common.Authorization = loginUser.token;
            commit('auth_success', loginUser);
            resolve(resp);
          })
          .catch((err) => {
            commit('auth_error');
            localStorage.removeItem('user');
            reject(err);
          });
      });
    },

    logout({ commit }) {
      return new Promise((resolve) => {
        commit('logout');
        localStorage.removeItem('user');
        delete axios.defaults.headers.common.Authorization;
        resolve();
      });
    },


  },

  getters: {
    isLoggedIn: state => !!state.user,
    isAdmin: state => state.user && state.user.access === 'admin',
    authStatus: state => state.status,
    nextPage: state => state.nextPage,
  },

});
